export default {
    title: "Adressverifikation",
    header: "@:views.address.verified.title",
    message: "Vielen Dank für die Bestätigung Ihrer Adresse. Sie können diese jetzt als Lieferadresse auswählen, wenn Sie eine Bestellung aufgeben.",
}